export default __webpack_public_path__ + "static/media/LogoSinLetras.9ac4bfc9.png";